import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import config from '../../../../../../config'

const MODULE_KEY = config.modules.report.key

function mapStateToProps(state) {
    const activeReportType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'reports', 'active'], null)

    const buttons = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )
    const sortedButtons = buttons
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => Map({ name: b.get('name'), disabled: b.get('isDisabled') }))

    const reports = state.getIn(['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports'], Map())
    const allowedReports = reports
        .toList()
        .sortBy((b) => b.get('order'))
        .filter((b) => b.get('isAllowed'))
        .map((b) =>
            Map({
                name: b.get('name'),
                disabled: b.get('isDisabled'),
            })
        )

    return {
        buttons: sortedButtons,
        reports: allowedReports,
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        static propTypes = {
            buttons: IPropTypes.list.isRequired,
            reports: IPropTypes.list.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (this.props.buttons && !this.props.buttons.equals(nextProps.buttons)) return true
            if (this.props.reports && !this.props.reports.equals(nextProps.reports)) return true
            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
